<template>
    <div>
        <b-overlay :show="budgetDownload">
            <CFTitle title="24. Buget - Activități și cheltuieli"></CFTitle>
            <div style="display: flex; justify-content: space-between; align-items: center;" class="mt-4 mb-4 pl-2 pr-2">
                <div>
                    <p>Descarcă bugetul tău completat în .xls sau .pdf</p>
                    <p>Bugetul este completat conform achizițiilor tale și respectă formatul Anexei 1. Bugetul va fi parte integrantă a cererii de finanțare.</p>
                </div>
                <div style="display: flex; justify-content: space-between; align-items: center; max-width: 150px;">
                    <img src="@/assets/images/M3/M3Sketch/pdf_icon.png" class="download-icon mr-3" alt="pdf_icon" @click="downloadBudget('pdf')">
                    <img src="@/assets/images/M3/M3Sketch/exel_icon.png" class="download-icon" alt="exel_icon" @click="downloadBudget('xlsx')">
                </div>
            </div>
        </b-overlay>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle";
    import axios from '@/helpers/axios'
    import api from '@/helpers/api'
    import { BOverlay } from 'bootstrap-vue'
    export default {
        components: {
            CFTitle,
            BOverlay
        },
        data() {
            return {
                budgetDownload: false
            }
        },
        mounted() {
            this.$store.dispatch('finantare/addToProgress', 'Buget - Activități și cheltuieli');
        },
        methods: {
            downloadBudget(type){
                this.budgetDownload = true
                let link = ''
                let name = JSON.parse(localStorage.getItem('currentM3Company')).name
                if(type === 'pdf'){
                    link = api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id +'/documents/spendings/xlsxToPdf'
                    name = 'buget_'+ name.replaceAll( /[^a-z0-9]+/ig, "_") +'.pdf'
                } else{
                    link = api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id +'/documents/spendings/xlsx'
                    name = 'buget_'+ name.replaceAll( /[^a-z0-9]+/ig, "_") +'.xlsx'
                }
                axios({url: link, method: 'GET', responseType: 'blob'})
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', name);
                        document.body.appendChild(link);
                        link.click();
                        this.budgetDownload = false
                    })
                    .catch(() => {
                        this.$swal({
                            title: 'Document disponibil companiilor cu licență activă.<br>Poți cumpăra o licență din pagina de mai jos.',
                            icon: 'info',
                            confirmButtonText: 'Cumpără licență',
                            showDenyButton: true,
                            denyButtonText: 'Anulează'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.$router.push({name: 'M3SketchCumparaLicenta'});
                            }
                        })
                        this.budgetDownload = false
                    })
            }
        }
    }
</script>

<style scoped>
.download-icon{
    cursor: pointer;
}
</style>